import React from "react";

import { Album, Resource } from 'app/api/types';

import "./styles.scss";
import Modal from 'react-modal';
import AddResource from '../AddResource';
import EditResource from '../EditResource';

interface IProps {
  album: Album;
  isActive: boolean;
  onSubmit: (data: Resource, file: File, preview?: File) => void;
  onDelete: (data: Resource) => void;
}

interface IState {
  modalIsOpen: boolean,
  resource?: Resource,
  isEdit: boolean,
  isSuccessActive: boolean,
  isSubmit: boolean,
}

class ManageResourcesForm extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    resource: undefined,
    isEdit: false,
    isSuccessActive: false,
    isSubmit: false,
  };

  openModal = () => {
    this.setState({ modalIsOpen: true, isEdit: false });
  };

  openEditModal = (value: Resource) => {
    this.setState({ modalIsOpen: true, isEdit: true, resource: value });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addResource = (data: Resource, file?: File, preview?: File) => {
    this.props.onSubmit(data, file!, preview);
    this.setState({ isSubmit: false, isSuccessActive: false });
    this.closeModal();
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  render() {
    return <div
        className={`manager-resource__form ${this.props.isActive ? "active" : ""}`}
    >
      <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Add phrase modal"
          className="user-group__modal"
          overlayClassName="user-group__overlay"
      >
        <button onClick={this.closeModal} className="modal-close" />
        {
          this.state.isEdit ? <EditResource
              resource={this.state.resource!}
              onSubmit={this.addResource}
              onSuccessChange={this.onSuccessChange}
              isSubmit={this.state.isSubmit}
          /> : <AddResource
              onSubmit={this.addResource}
              onSuccessChange={this.onSuccessChange}
              isSubmit={this.state.isSubmit}
          />
        }
        {this.state.isSuccessActive && (
            <button
                onClick={() => this.setState({ isSubmit: true })}
                className="modal-success"
            />
        )}
      </Modal>
      <div className="resources_add">
        <div className="header__group-label">
          <p className="label__text">Фото и видео</p>
          <p className="label__counter">{this.props.album.resources.length}</p>
          <button className="label__add-button" onClick={this.openModal} />
        </div>
      </div>
      <div className="resources">
        {this.props.album.resources.map(item => (
            <div style={{ background: `url('${item.previewUrl}')`, backgroundSize: 'cover' }} key={item.id}
                 className="image_resource">
              <p className="phrase-edit" onClick={() => this.openEditModal(item)}>изменить</p>
              <p className="phrase-del" onClick={() => this.props.onDelete(item)}>удалить</p>
            </div>
        ))}
      </div>
    </div>
  };
};

export default ManageResourcesForm;
